import { render, staticRenderFns } from "./layout-loader-item.vue?vue&type=template&id=d46ade44&scoped=true&"
var script = {}
import style0 from "./layout-loader-item.vue?vue&type=style&index=0&id=d46ade44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46ade44",
  null
  
)

export default component.exports